export default {
  title: 'Exceções de Horário',
  fields: {
    status: {
      label: 'Estado',
    },
    date: {
      label: 'Data',
    },
    description: {
      label: 'Motivo',
    },
    recurring: {
      label: 'Recorrência anual',
    },
    created: {
      label: 'Criado',
      creator: 'por {{name}}',
    },
    updated: {
      label: 'Atualizado',
    },
  },
  status: {
    closed: 'Fechado',
    open: 'Aberto',
    paused: 'Em pausa',
  },
  date: {
    all_day: 'Dia inteiro',
    paused_until_rest_of_day: 'Em pausa até ao fim do dia',
  },
  buttons: {
    pause_availability: '+ Pausar Disponibilidade',
    close_availability: '+ Fechar Disponibilidade',
    amend_availability: '+ Alterar Disponibilidade',
    sync_from_online_shop: 'Sincronizar da Loja Online',
    close: 'Fechar',
    delete: 'Eliminar',
  },
  projects: {
    online_shop: 'Loja Online',
    reservations: 'Reservas',
    storefront: 'Storefront',
  },
  error_messages: {
    delete_failed: 'Falha ao eliminar. Tente novamente.',
  },
  toasts: {
    sync_success: 'Sincronizado com sucesso',
    sync_error: 'Falha ao sincronizar exceções de horário da loja online. Tente novamente.',
  },
};
